import { SettingsPopUpButtonModule } from './../../../widgets/settings-pop-up-button/settings-pop-up-button.module';
import { MapboxMapModule } from './../../../widgets/mapbox-map/mapbox-map.module';
import { ControlPopUpModule } from '../../../widgets/control-pop-up/control-pop-up.module';
import { LeafletGeoJsonLayerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-geo-json-layer/leaflet-geo-json-layer.module';
import { LeafletArcModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-arc/leaflet-arc.module';
import { LeafletTileLayerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-tile-layer/leaflet-tile-layer.module';
import { LeafletCircleModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-circle/leaflet-circle.module';
import { LeafletCircleMarkerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-circle-marker/leaflet-circle-marker.module';
import { LeafletMapModule } from './../../../widgets/leaflet-map/leaflet-map.module';
import { DxSwitchModule, DxSelectBoxModule, DxAutocompleteModule, DxButtonModule } from 'devextreme-angular';
import { FiltersGroupModule } from './../../../widgets/filters/filters-group/filters-group.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MapRoutingModule } from './map-routing.module';
import { MapComponent } from './map/map.component';


@NgModule({
	declarations: [MapComponent],
	imports: [
		CommonModule,
		MapRoutingModule,

		FiltersGroupModule,
		ControlPopUpModule,

		SettingsPopUpButtonModule,

		LeafletMapModule,
		LeafletTileLayerModule,
		LeafletGeoJsonLayerModule,
		LeafletCircleMarkerModule,
		LeafletCircleModule,
		LeafletArcModule,

		MapboxMapModule,

		DxSwitchModule,
		DxSelectBoxModule,
		DxAutocompleteModule,
		DxButtonModule,
	]
})
export class MapModule { }
